
export interface ExifInitializationRule {
  type: 'exif';
  /**
   * Given an object representing the exif data like:
   *
   * {
   *   a: {
   *     b: {
   *       foo: 'bar'
   *     }
   *   }
   * }
   *
   * this array should contain the path to the leaf node to
   * copy the value from, including the names of the nested objects
   * like: ['a', 'b', 'foo']
   */
  pathToLeaf: string[];
}

export interface DateOffsetInitializationRule {
  type: 'dateOffset';
  /**
   * offsetDays should contain days (positive or negative) to add or subtract from a
   * DateField that contains this type of initialization rule.
   */
  offsetDays: number;
}

export type MdfFieldInitializationRule = ExifInitializationRule | DateOffsetInitializationRule;

export function isDateOffsetRule(rule: MdfFieldInitializationRule): rule is DateOffsetInitializationRule {
  return rule.type === 'dateOffset';
}
